import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import ApiClient from '../../utils/ApiClient';
import AppNav from '../../components/AppNav/AppNav';
import { Link } from 'react-router-dom';
import { tokenRequest } from '../../authConfig';

function FormInstanceLogPage() {
  const { instance } = useMsal();

  const [ logEntries, setLogEntries ] = useState([]);
  const [ fetchingLogEntries, setFetchingLogEntries ] = useState([]);

  useEffect(() => {
    const fetchLogEntries = async () => {
      setFetchingLogEntries(true);
      try {
        const response = await ApiClient.get('/admin/logs/formInstanceLog', {
          headers: {
            'Authorization': `Bearer ${(await instance.acquireTokenSilent({account: instance.getActiveAccount(), scopes: tokenRequest.scopes})).accessToken}`
          }
        });

        setLogEntries(response.data);
      } catch (e) {

      } finally {
        setFetchingLogEntries(false);
      }
    };

    fetchLogEntries();
  }, [instance]);

  return (
    <div>
      <AppNav />
      <div className="container">
        <h1>Formular Log</h1>

        <table className="table table-striped">
          <thead>
          <tr>
            <th scope="col">FormCode</th>
            <th scope="col">Hash</th>
            <th scope="col">Status</th>
            <th scope="col">Details</th>
          </tr>
          </thead>
          <tbody>
          {
            fetchingLogEntries ? (
              <tr>
                <th scope="row" colSpan="5">
                  Lade Daten
                </th>
              </tr>
            ) : logEntries.length === 0 ? (
              <tr>
                <th scope="row" colSpan="5">
                  Keine Logs gefunden
                </th>
              </tr>
            ) : logEntries.map((logEntry) => (
              <tr key={logEntry.hash}>
                <td>
                  { logEntry.formCode }
                </td>
                <td>
                  { logEntry.hash }
                </td>
                <td>
                  { logEntry.state }
                </td>
                <td>
                  <Link to={`/panel/logs/formInstances/${logEntry.hash}`}>Details</Link>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FormInstanceLogPage;
